$ = require 'jquery'
OS = require './models/os'
{ getParams, getParam } = require '../components/paramas'

module.exports =
class Redirect

  constructor: ->
    { @mobile } = OS.getInstance()

    return unless @mobile

    protocol = location.protocol
    host     = location.host
    pathname = location.pathname
    query    = location.search

    return if pathname.match /^\/sp/
    spPathname = "/sp#{pathname}"

    if query
      if getParam 'page'
        params = getParams()
        delete params.page
        query = $.param(params)
        if query
          query = "?#{query}"

    location.href = "#{protocol}//#{host}#{spPathname}#{query}"



// WEBPACK FOOTER //
// ./webpack/requires/pc/redirect.coffee